export const RewardCalculationQueries = {
  GET_REWARD_CALCULATION: `query GetReward($input: GetRewardInput!, $skip: Float, $take: Float) {
  getReward(input: $input, skip: $skip, take: $take) {
    pageInfo{
        hasNextPage
        hasPreviousPage
        itemsPerPage
        currentPage
        totalItems
        totalPages
    }
    items {
      id
      actualAmount
      groupId
      groupRoleManagementId
      unitName
      hotRewardAmount
      jobTitleCode
      jobTitleName
      modifyId
      modifyDate
      createId
      createDate
      note
      objectType
      percentPlanVsActual
      plantId
      plantName
      planAmount
      retireDate
      rewardLastMonth
      trewardSetup{
        type
        supportYn
        ttype{
            id
            name
        }
      }
      rewardSeqment_1
      rewardSeqment_2
      rewardSeqment_3
      rewardSeqment_4
      rewardSeqmentAmount_1
      rewardSeqmentAmount_2
      rewardSeqmentAmount_3
      rewardSeqmentAmount_4
      rewardSetupId
      signDate
      totalExpenEndPeriod
      totalReward
      unitName
      userRewardId
      userRewardName
      yearReward
      monthReward
      kpiDate
      tcreateUser {
        id
        fullName
      }
      tmodifyUser {
        id
        fullName
      }
      trewardSetup {
        type
      }
    }
  }
}
`,

  REWARD_CALCULATION: `query calculateReward($input: CalculateRewardInput!){
    calculateReward(input: $input){
        id
      actualAmount
      groupId
      groupRoleManagementId
      hotRewardAmount
      jobTitleCode
      jobTitleName
      modifyId
      modifyDate
      createId
      createDate
      note
      objectType
      percentPlanVsActual
      plantId
      plantName
      planAmount
      retireDate
      rewardLastMonth
      rewardSeqment_1
      rewardSeqment_2
      rewardSeqment_3
      rewardSeqment_4
      rewardSeqmentAmount_1
      rewardSeqmentAmount_2
      rewardSeqmentAmount_3
      rewardSeqmentAmount_4
      rewardSetupId
      signDate
      totalExpenEndPeriod
      totalReward
      unitName
      userRewardId
      userRewardName
      tcreateUser {
        id
        fullName
      }
      tmodifyUser {
        id
        fullName
      }
    }
}`,
  SAVE_REWARD_CALCULATION: ``,
  // calculate Reward For TeamSale
  CALCULATE_REWARD_FOR_TEAM_SALE: `mutation calculateRewardForTeam($input: CalculateRewardForTeamInput!){
    calculateRewardForTeam(input: $input){
        message
        success
    }
}`,
  // calculate Reward For Plant
  CALCULATE_REWARD_FOR_PLANT: `mutation calculateRewardForPlant($input: CalculateRewardForPlantInput!){
    calculateRewardForPlant(input: $input){
        message
        success
    }
}`,
  // Update hot Reward Amount
  UPDATE_HOT_REWARD_AMOUNT: `mutation UpdateReward($input: UpdateRewardInput!){
    updateReward(input: $input){
        id
        hotRewardAmount
        userRewardId
        rewardLastMonth
        note
    }
}`,
};
